import React, { useContext, useState } from "react";
import { graphql, useFragment } from "react-relay";

import cx from "classnames";

import ViewportContext from "~/common/ViewportContext";
import SimpleTabs from "~/ui/Tabs";

import { NoteTemplateContentRenderer } from "./content";
import { TemplateMetadata } from "./Metadata";

import type { PreviewNoteTemplate$key } from "~/__generated__/PreviewNoteTemplate.graphql";

import styles from "./css/Preview.module.css";

const previewFragment = graphql`
	fragment PreviewNoteTemplate on NoteTemplateNode {
		id
		...MetadataNoteTemplate
	}
`;

export function TemplatePreview({
	className,
	template: templateKey,
}: {
	className?: string;
	template: PreviewNoteTemplate$key;
}) {
	const { isMobile } = useContext(ViewportContext);

	const template = useFragment(previewFragment, templateKey);

	if (isMobile) return <MobileTemplatePreview template={templateKey} />;

	return (
		<div className={cx(styles.preview, className)}>
			<div className={styles.metadata}>
				<TemplateMetadata template={template} className={styles.metadataContent} />
			</div>
			<div className={styles.contents}>
				<div className={styles.previewTag}>This is a preview</div>
				<NoteTemplateContentRenderer readOnly templateId={template.id} />
			</div>
		</div>
	);
}

const tabs = ["Preview", "About"];
type Tab = (typeof tabs)[number];

function MobileTemplatePreview({ template: templateKey }: { template: PreviewNoteTemplate$key }) {
	const [tab, setTab] = useState<Tab>("Preview");
	const template = useFragment(previewFragment, templateKey);

	return (
		<div className={styles.mobileContainer}>
			<SimpleTabs tab={tab} setTab={setTab} tabs={tabs} className={styles.tabs} />
			{tab === "Preview" && (
				<div className={styles.mobileContentContainer}>
					<NoteTemplateContentRenderer readOnly proseReactClassName={styles.contents} templateId={template.id} />
					<div className={styles.previewTag}>This is a preview</div>
				</div>
			)}
			{tab === "About" && (
				<div className={styles.mobileMetadata}>
					<TemplateMetadata template={template} className={styles.metadataContent} />
				</div>
			)}
		</div>
	);
}
